export enum BadgeVariants {
    gray = "gray",
    grayMid = "grayMid",
    grayDark = "grayDark",
    red = "red",
    orange = "orange",
    yellow = "yellow",
    green = "green",
    blue = "blue",
    indigo = "indigo",
    purple = "purple",
    pink = "pink",
    grayOutline = "gray-outline",
    redOutline = "red-outline",
    yellowOutline = "yellow-outline",
    greenOutline = "green-outline",
    blueOutline = "blue-outline",
    indigoOutline = "indigo-outline",
    purpleOutline = "purple-outline",
    pinkOutline = "pink-outline",
}

export type BadgeVariant =
    | "gray"
    | "grayMid"
    | "grayDark"
    | "red"
    | "orange"
    | "yellow"
    | "green"
    | "blue"
    | "indigo"
    | "purple"
    | "pink"
    | "gray-outline"
    | "red-outline"
    | "yellow-outline"
    | "green-outline"
    | "blue-outline"
    | "indigo-outline"
    | "purple-outline"
    | "pink-outline";
